let initialized = false;

export function initObservability(): void {
  if (initialized) return;
  initialized = true;

  const sentryDsn = import.meta.env.STOREFRONT_SENTRY_DSN;
  const posthogKey = import.meta.env.STOREFRONT_POSTHOG_KEY;
  const posthogHost = import.meta.env.STOREFRONT_POSTHOG_HOST ?? 'https://us.i.posthog.com';

  if (!sentryDsn) {
    console.warn('[storefront] STOREFRONT_SENTRY_DSN not set — crash reporting disabled');
  } else {
    void import('@sentry/react').then((Sentry) => {
      Sentry.init({
        dsn: sentryDsn,
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
      });
    });
  }

  if (!posthogKey) {
    console.warn('[storefront] STOREFRONT_POSTHOG_KEY not set — analytics disabled');
  } else {
    void import('posthog-js').then(({ default: posthog }) => {
      posthog.init(posthogKey, { api_host: posthogHost, person_profiles: 'identified_only' });
    });
  }
}
